import {
  useEffect,
  useState,
} from "react";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  MINIMAL SCROLL PROGRESS
  ============================================================

  Desktop:
  - siro pystysuuntainen progress oikeassa reunassa
  - pieni piste näyttää nykyisen kohdan
  - ei numeroita eikä tekstejä

  Mobile / tablet:
  - ohut progress-viiva yläreunassa
*/

function clamp(
  value,
  min,
  max
) {
  return Math.min(
    max,
    Math.max(
      min,
      value
    )
  );
}

export default function HomeScrollTracker() {
  const [
    progress,
    setProgress,
  ] = useState(0);

  useEffect(() => {
    let frame = null;

    const updateProgress =
      () => {
        frame = null;

        const scrollTop =
          window.scrollY ||
          document.documentElement.scrollTop ||
          0;

        const pageHeight =
          document.documentElement.scrollHeight;

        const viewportHeight =
          window.innerHeight;

        const scrollableHeight =
          Math.max(
            1,
            pageHeight -
              viewportHeight
          );

        setProgress(
          clamp(
            scrollTop /
              scrollableHeight,
            0,
            1
          )
        );
      };

    const requestUpdate =
      () => {
        if (
          frame !== null
        ) {
          return;
        }

        frame =
          window.requestAnimationFrame(
            updateProgress
          );
      };

    updateProgress();

    window.addEventListener(
      "scroll",
      requestUpdate,
      {
        passive: true,
      }
    );

    window.addEventListener(
      "resize",
      requestUpdate
    );

    return () => {
      window.removeEventListener(
        "scroll",
        requestUpdate
      );

      window.removeEventListener(
        "resize",
        requestUpdate
      );

      if (
        frame !== null
      ) {
        window.cancelAnimationFrame(
          frame
        );
      }
    };
  }, []);

  const percentage =
    `${progress * 100}%`;

  return (
    <>
      {/* ======================================================
          MOBILE / TABLET
          ====================================================== */}

      <div
        className="
          pointer-events-none
          fixed
          inset-x-0
          top-0
          z-[150]
          h-[2px]
          bg-text/10

          lg:hidden
        "
        aria-hidden="true"
      >
        <div
          className="
            h-full
            bg-text/80
          "
          style={{
            width:
              percentage,
          }}
        />
      </div>

      {/* ======================================================
          DESKTOP
          ====================================================== */}

      <div
        className="
          pointer-events-none
          fixed
          right-4
          top-1/2
          z-[100]
          hidden
          h-[120px]
          w-[5px]
          -translate-y-1/2

          lg:block

          xl:right-6
        "
        aria-hidden="true"
      >
        {/* TRACK */}

        <div
          className="
            absolute
            left-1/2
            top-0
            h-full
            w-px
            -translate-x-1/2
            bg-text/15
          "
        />

        {/* FILLED PART */}

        <div
          className="
            absolute
            left-1/2
            top-0
            w-px
            -translate-x-1/2
            bg-text/80
          "
          style={{
            height:
              percentage,
          }}
        />

        {/* CURRENT POSITION */}

        <div
          className="
            absolute
            left-1/2
            h-[5px]
            w-[5px]
            -translate-x-1/2
            -translate-y-1/2
            rounded-full
            bg-text
            shadow-[0_0_0_3px_rgba(255,255,255,0.45)]
          "
          style={{
            top:
              percentage,
          }}
        />
      </div>
    </>
  );
}